import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Store from './Store';
import {Provider} from 'react-redux';

ReactDOM.render(<Provider store={Store}><App/></Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

if(process.env.REACT_APP_URL_CommonComponent){
        const script = document.createElement("script");
        script.src = `${process.env.REACT_APP_URL_CommonComponent}/plugin.js`;
        script.async = true;
        document.body.appendChild(script);
}

serviceWorker.unregister();
